import { Injectable } from '@angular/core';
import { Message, MessageGroup, MessageGroupEngine } from '@pixacare/chat';
import { InsertionType } from '@pixacare/shared';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class MessageGroupService {
  messageGroups$: Observable<MessageGroup[]>;

  private _messageGroups$: BehaviorSubject<MessageGroup[]> = new BehaviorSubject<MessageGroup[]>([]);
  private engine = new MessageGroupEngine();

  constructor() {
    this.messageGroups$ = this._messageGroups$.asObservable();
  }

  addMessages(messages: Message[], insertionType: InsertionType = 'append', lastDisplayedMessage?: Message): void {
    this._messageGroups$.next(this.engine.addMessages(messages, insertionType, lastDisplayedMessage));
  }

  reset(): void {
    this.engine.reset();
    this._messageGroups$.next([]);
  }
}
